import { Card, CardContent } from '@material-ui/core'
import { saveBomItemComment } from 'features/BillOfMaterials/store/asyncActions/saveComment'
import { ProjectTextField } from 'features/BillOfMaterials/store/components/ProjectTextField'
import { bomItemCommentSelector } from 'features/BillOfMaterials/store/selectors/bomItemCommentSelector'
import { projectSelectors } from 'features/BillOfMaterials/store/selectors/projectSelectors'
import { useTranslation } from 'react-i18next'
import { useAppSelector } from 'store/configureStore'
import { useCommentFormStyles } from './CommentForm.styles'

export const CommentForm = ({ bomItemId }: { bomItemId: string }) => {
  const classes = useCommentFormStyles()
  const { t } = useTranslation()
  const editable = useAppSelector(projectSelectors.ProjectEditableStateSelector)

  return (
    <Card className={classes.actions}>
      <CardContent>
        <ProjectTextField
          valueSelector={bomItemCommentSelector(bomItemId)}
          actionTypePrefix={saveBomItemComment.typePrefix.concat(
            '/',
            bomItemId
          )}
          saveAction={(value) =>
            saveBomItemComment({ bomItemId, comment: value })
          }
          textFieldProps={{
            label: t('common:comment'),
            maxRows: 4,
            multiline: true,
            fullWidth: true,
            inputProps: {
              maxLength: 140,
            },
            autoFocus: true,
            disabled: !editable,
          }}
          helperTextFunc={(value) =>
            t('common:chars-left', {
              defaultValue: '{{count}} characters left',
              count: 140 - (value || '').length,
            })
          }
        />

        {/* <TextField
            label={t('common:comment')}
            fullWidth
            multiline
            maxRows={4}
            value={commentText || ''}
            onChange={onChange}
            inputProps={{
              maxLength: 140,
            }}
            onKeyDown={handleEnterKey}
            autoFocus
          />
          <div className={classes.actions}>
            <Typography component="p" variant="caption" color="textSecondary">
              {t('common:chars-left', {
                defaultValue: '{{count}} characters left',
                count: 140 - (commentText || '').length,
              })}
            </Typography>
          </div> */}
      </CardContent>
      {/* <CardActions>
          <SaveButton
            saving={loading[`update-comment-${bomItemId}`]}
            disabled={comment === commentText}
            size="small"
          />
        </CardActions> */}
    </Card>
  )
}
